import React, {useEffect} from "react";
import SVG from "react-inlinesvg";
import {Modal} from "react-bootstrap";
import {formatAmount} from "../../../../util/Helpers";
import {toAbsoluteUrl} from "../../../../../_metronic/_helpers";
import {useCancelOrderMutation} from "../../../../../redux/apiSlice";
import cogoToast from "cogo-toast";

const CancelOrderModal = ({showCancelOrderModal, details, provider, onHide, tableRef, refreshOrders}) => {

    const [
        cancelOrder,
        {
            isLoading: isCancelling,
            isSuccess: cancellationSuccessful,
        }
    ] = useCancelOrderMutation()

    /* Close Modal on successful update */
    useEffect(() => {
        if (cancellationSuccessful) {
            cogoToast.success("Order Cancellation Successfully")
            onHide();
            if (refreshOrders) {
                refreshOrders();
            }
        }
    }, [cancellationSuccessful, onHide, refreshOrders]);

    /* Cancel Order */
    const cancel = () => {
        const {progress, status} = details

        cancelOrder({
            id: details?.id,
            userId: details.userId,
            meta: {
                progress,
                status,
                provider,
            }
        })
    }

    return (
        <Modal
            show={showCancelOrderModal}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            backdrop={isCancelling ? "static" : true}
            keyboard={!isCancelling}
        >

            <Modal.Header>
                <Modal.Title id="contained-modal-title-vcenter">
                    <span className={`svg-icon svg-icon-lg svg-icon-danger mr-3`}>
                        <SVG
                            title=""
                            src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart3.svg")}
                        />
                    </span>
                    Cancel Order Confirmation
                </Modal.Title>
                <button type="button" className="close" onClick={onHide}>
                    <span aria-hidden="true" className="d-block">×</span>
                    <span className="sr-only">Close</span>
                </button>
            </Modal.Header>
            <Modal.Body
                className="px-10 py-2"
            >
                <h5
                    className="text-center font-weight-light py-5"
                >
                    Do you really want to
                    cancel <b>{`${details?.side} of ${details?.quantity ? `${details?.quantity}` : formatAmount(details?.currency, details?.amount)} ${details?.symbol}`}</b> ?
                </h5>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">

                <button
                    type="button"
                    onClick={onHide}
                    className="btn btn-light btn-elevate px-4"
                >
                    Close
                </button>
                <> </>
                <button
                    type="button"
                    onClick={_ => cancel()}
                    className="btn btn-danger btn-elevate px-4 ml-4"
                    disabled={isCancelling}
                >
                    Cancel Order
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CancelOrderModal;